const messages = JSON.parse('{"faq":{"open":"開く","close":"閉じる"}}');
export default messages;